module.exports = __webpack_public_path__ + "static/img/signin-lcic-inactive.a72a5363.svg";